import SocialAccounts from './SocialAccounts';

export default SocialAccounts;



// WEBPACK FOOTER //
// ./src/SocialAccounts/index.js